export class Dealer {
	idDealer: number;
	address?: string;
	businessName?: string;
	buyingInterest?: string;
	carSold?: number;
	city?: string;
	confEmail?: string;
	country?: string;
	email?: string;
	idMarket?: string;
	mobile?: string;
	phone?: string;
	region?: string;
	sincom?: string;
	iamCode?: string;
	postalCode?: string;
	referenceBirthDate?: string;
	referenceEmail?: string;
	referenceFCA?: string;
	referenceFiscalCode?: string;
	referenceName?: string;
	referenceSurname?: string;
	typeDealerActivity?: string;
	vatCode?: string;
	website?: string;
	flgEnabled: boolean;
	flgIam: boolean;
	flgNoUsers: boolean;
	flgConfigured: boolean;
	flgMultiAuctioneer: boolean;
	note?: string;
	flgInvalidVat?: boolean;
	regon?: string;
}


export class DealerParams {
	idDealer: number;
	businessName?: string;
	vatCode?: string;
	username?: string;
	city?: string;
	region?: string;
	postalCode?: string;
	email?: string;
	country?: string;
	createFrom?: string; // ISO Date string
	createTo?: string; // ISO Date string
}

export class DealerInternalReferenceDTO {
	birthDate?: Date;
	email?: string;
	fcaNote?: string;
	fiscalCode?: string;
	id?: number;
	idDealer?: number;
	name?: string;
	surname?: string;
	permission?: string;
	flgInProgress?: boolean;
	idRichiesta?: number;
}

export class DealerReferenceDTO {
	businessName?: string;
	idDealer?: string;
	vatCode?: string;
	idMarket?: string;
}

export interface DealerInfoDTO {
	idMarket?: string;
	businessName?: string;
	idDealer?: number;
	city?: string;
	vatCode?: string;
	address?: string;
	country?: string;
	phone?: string;
	mobile?: string;
	email?: string;
	postalCode?: string;
	referenceSurname?: string;
	flgAuctioneer?: boolean;
	flgMultiAuctioneer?: boolean;
}
